"use client";

import { ListboxOption } from "@headlessui/react";
import clsx from "clsx";
import Icon from "../Icon";
import { SelectOptionProps } from "./types";

const SelectOption = <T,>({ children, value, size }: SelectOptionProps<T>) => {
  return (
    <ListboxOption value={value}>
      {({ active, selected }) => (
        <div
          className={clsx(
            "cursor-pointer px-s py-2xs w-full flex justify-between items-center hover:bg-neutral-12",
            {
              "bg-neutral-25": active,
              "bg-neutral-12": selected,
              "text-body-2": size === "md",
              "text-app-body-2": size === "sm",
            },
          )}
        >
          <span className="whitespace-nowrap text-ellipsis overflow-hidden">
            {children}
          </span>
          {selected && (
            <Icon type="Check" className="text-primary-800 ml-2xs" size={20} />
          )}
        </div>
      )}
    </ListboxOption>
  );
};

export default SelectOption;
